/**
 * Learn More — scroll reveal (fade-up / image reveal)
 * Vanilla JS only. Scoped via [data-lm-reveal].
 */
(function () {
  const SELECTOR = '[data-lm-reveal]';
  const VISIBLE = 'is-visible';
  let observer = null;

  function shouldSkipMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function revealAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(function (el) {
      el.classList.add(VISIBLE);
    });
  }

  function observe(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const nodes = scope.querySelectorAll(SELECTOR);

    if (!nodes.length) return;

    if (shouldSkipMotion() || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.classList.add(VISIBLE);
      });
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add(VISIBLE);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
    }

    nodes.forEach(function (el) {
      if (el.classList.contains(VISIBLE)) return;
      observer.observe(el);
    });
  }

  function init(root) {
    observe(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function () {
    /* no-op: observer auto-unobserves on reveal */
  });
})();
